import React, { useState, useEffect } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "./SideNavBar.css";
import { hasUserRole, getStudentId } from "../../utils";
import Api from "../../api";
import logo_spc from "../../assets/icons/colored/logo-spc.svg";
import log_out from "../../assets/icons/colored/Log_Out.svg";
import imageSrc1_svg from "../../assets/icons/colored/More_Square.svg";
import imageSrc2_svg from "../../assets/icons/colored/Board.svg";
import imageSrc3_svg from "../../assets/icons/colored/Document.svg";
import imageSrc4_svg from "../../assets/icons/colored/Pen.svg";
import imageSrc5_svg from "../../assets/icons/colored/Calender.svg";
import imageSrc6_svg from "../../assets/icons/colored/Call.svg";
import imageSrc7_svg from "../../assets/icons/colored/Admin.svg";
import imageSrc8_svg from "../../assets/icons/colored/Attendance.svg";
import imageSrc9_svg from "../../assets/icons/colored/Code.svg";
import imageSrc11_svg from "../../assets/icons/colorless/More_Square.svg";
import imageSrc22_svg from "../../assets/icons/colorless/Board.svg";
import imageSrc33_svg from "../../assets/icons/colorless/Document.svg";
import imageSrc44_svg from "../../assets/icons/colorless/Pen.svg";
import imageSrc55_svg from "../../assets/icons/colorless/Calender.svg";
import imageSrc66_svg from "../../assets/icons/colorless/Call.svg";
import imageSrc77_svg from "../../assets/icons/colorless/Admin.svg";
import imageSrc88_svg from "../../assets/icons/colorless/Attendance.svg";
import imageSrc99_svg from "../../assets/icons/colorless/Code.svg";

const SideNavBar = () => {
  const navigate = useNavigate();
  const [isExpanded, setExpendState] = useState(window.innerWidth > 1024);

  const handleLogout = () => {
    Cookies.remove("token");
    navigate("/");
  };

  const handleMenuClick = () => {
    if (window.innerWidth <= 1024) {
      setExpendState(false);
    }
  };

  const [imageSrc1, setImageSrc1] = useState(imageSrc1_svg);
  const [imageSrc2, setImageSrc2] = useState(imageSrc2_svg);
  const [imageSrc3, setImageSrc3] = useState(imageSrc3_svg);
  const [imageSrc4, setImageSrc4] = useState(imageSrc4_svg);
  const [imageSrc5, setImageSrc5] = useState(imageSrc5_svg);
  const [imageSrc6, setImageSrc6] = useState(imageSrc6_svg);
  const [imageSrc7, setImageSrc7] = useState(imageSrc7_svg);
  const [imageSrc8, setImageSrc8] = useState(imageSrc8_svg);
  const [imageSrc9, setImageSrc9] = useState(imageSrc9_svg);
  const [showCodeMenu, setShowCodeMenu] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1280) {
        setExpendState(true);
      } else {
        setExpendState(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Si el menú está expandido y el clic es fuera del menú, lo colapsamos
      if (
        isExpanded &&
        window.innerWidth <= 1024 &&
        !document.querySelector(".side-nav-container").contains(event.target)
      ) {
        setExpendState(false);
      }
    };

    // Agregar el evento al hacer clic en cualquier parte de la pantalla
    document.addEventListener("click", handleClickOutside);

    return () => {
      // Remover el evento cuando el componente se desmonte
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isExpanded]); // Se ejecuta cuando cambia isExpanded

  const changeImage1 = (newSrc1) => {
    setImageSrc1(newSrc1);
  };
  const changeImage2 = (newSrc2) => {
    setImageSrc2(newSrc2);
  };
  const changeImage3 = (newSrc3) => {
    setImageSrc3(newSrc3);
  };
  const changeImage4 = (newSrc4) => {
    setImageSrc4(newSrc4);
  };
  const changeImage5 = (newSrc5) => {
    setImageSrc5(newSrc5);
  };
  const changeImage6 = (newSrc6) => {
    setImageSrc6(newSrc6);
  };
  const changeImage7 = (newSrc7) => {
    setImageSrc7(newSrc7);
  };
  const changeImage8 = (newSrc8) => {
    setImageSrc8(newSrc8);
  };
  const changeImage9 = (newSrc9) => {
    setImageSrc9(newSrc9);
  };

  useEffect(() => {
    const checkCodeProgram = async () => {
      if (hasUserRole(["ROLE_STUDENT"])) {
        const studentId = getStudentId();
        if (studentId) {
          try {
            const response = await Api.Code.CheckProgram(studentId);
            if (response && response.inProgram) {
              setShowCodeMenu(true);
            }
          } catch (error) {
            console.error("Error checking code program:", error);
          }
        }
      }
    };
    checkCodeProgram();
  }, []);

  return (
    <>
      <div
        className={
          isExpanded
            ? "side-nav-container"
            : "side-nav-container side-nav-container-NX"
        }
      >
        <div className="nav-upper">
          <div className={isExpanded ? "nav-heading" : "nav-heading_NX"}>
            {isExpanded && (
              <>
                <div className="logo-spc">
                  <img src={logo_spc} alt="logo-spc.svg" />
                </div>
                <div className="nav-brand">
                  <div className="spc">
                    <h2>SPC</h2>
                  </div>
                  <div className="spc-l">
                    <p>Sistema de Programacion Canadian</p>
                  </div>
                </div>
              </>
            )}
            <button
              className={
                isExpanded
                  ? "hamburger hamburger-in"
                  : "hamburger hamburger-out"
              }
              onClick={() => setExpendState(!isExpanded)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div className="inb-controller">
            <hr className="in-between" />
          </div>
          <div className="nav-menu">
            {/* Img 1 */}
            {hasUserRole(["ROLE_ADMIN", "ROLE_STUDENT", "ROLE_TEACHER"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./dashboard"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage1(imageSrc11_svg)}
                onMouseLeave={() => changeImage1(imageSrc1_svg)}
              >
                <img
                  className="menu-item-icon"
                  src={imageSrc1}
                  alt="More_Square.svg"
                />
                {isExpanded && <p>Inicio</p>}
              </Link>
            )}
            {/* Code Menu - Only for students in program */}
            {showCodeMenu && hasUserRole(["ROLE_STUDENT"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./code"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage9(imageSrc99_svg)}
                onMouseLeave={() => changeImage9(imageSrc9_svg)}
              >
                <img
                  className="menu-item-icon"
                  src={imageSrc9}
                  alt="Code.svg"
                />
                {isExpanded && <p>Código</p>}
              </Link>
            )}
            {/*Admin Img */}
            {hasUserRole(["ROLE_ADMIN"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./admindashboard"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage7(imageSrc77_svg)}
                onMouseLeave={() => changeImage7(imageSrc7_svg)}
              >
                <img
                  className="menu-item-icon"
                  src={imageSrc7}
                  alt="Admin.svg"
                />
                {isExpanded && <p>Admin</p>}
              </Link>
            )}
            {/* Attendance */}
            {hasUserRole(["ROLE_TEACHER"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./class_attendance"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage8(imageSrc88_svg)}
                onMouseLeave={() => changeImage8(imageSrc8_svg)}
              >
                <img
                  className="menu-item-icon"
                  src={imageSrc8}
                  alt="Attendance.svg"
                />
                {isExpanded && <p>Profesor</p>}
              </Link>
            )}
            {/* Img2 */}
            {hasUserRole(["ROLE_STUDENT"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./standard_class"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage2(imageSrc22_svg)}
                onMouseLeave={() => changeImage2(imageSrc2_svg)}
              >
                <img
                  className="menu-item-icon"
                  src={imageSrc2}
                  alt="Board.svg"
                />
                {isExpanded && <p>Clases</p>}
              </Link>
            )}
            {/* Img3 */}
            {hasUserRole(["ROLE_STUDENT"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./workshop"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage3(imageSrc33_svg)}
                onMouseLeave={() => changeImage3(imageSrc3_svg)}
              >
                <img
                  className="menu-item-icon"
                  src={imageSrc3}
                  alt="Document.svg"
                />
                {isExpanded && <p>Talleres</p>}
              </Link>
            )}
            {/* Img4 */}
            {hasUserRole(["ROLE_STUDENT"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./Exams"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage4(imageSrc44_svg)}
                onMouseLeave={() => changeImage4(imageSrc4_svg)}
              >
                <img className="menu-item-icon" src={imageSrc4} alt="Pen.svg" />
                {isExpanded && <p>Examenes</p>}
              </Link>
            )}
            {/* Img5 */}
            {hasUserRole(["ROLE_STUDENT", "ROLE_TEACHER"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./my_schedule"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage5(imageSrc55_svg)}
                onMouseLeave={() => changeImage5(imageSrc5_svg)}
              >
                <img
                  className="menu-item-icon"
                  src={imageSrc5}
                  alt="Calender.svg"
                />
                {isExpanded && <p>Mi agenda</p>}
              </Link>
            )}
            {/* Img6 */}
            {hasUserRole(["ROLE_ADMIN", "ROLE_STUDENT", "ROLE_TEACHER"]) && (
              <Link
                className={isExpanded ? "menu-item" : "menu-item menu-item-NX"}
                to="./help"
                onClick={handleMenuClick}
                onMouseEnter={() => changeImage6(imageSrc66_svg)}
                onMouseLeave={() => changeImage6(imageSrc6_svg)}
              >
                <img
                  className="menu-item-icon"
                  src={imageSrc6}
                  alt="Call.svg"
                />
                {isExpanded && <p>Contactanos</p>}
              </Link>
            )}
          </div>
        </div>
        <div className="nav-footer">
          {isExpanded && (
            <div className="nav-details">
              <p>Canadian College</p>
            </div>
          )}

          <div>
            <button
              type="button"
              className="logout-button"
              onClick={handleLogout}
              aria-label="Cerrar sesión"
            >
              <img
                className={isExpanded ? "logout-icon" : "logout-icon-ue"}
                src={log_out}
                alt="Log_Out.svg"
              />
            </button>
          </div>
        </div>
      </div>

      <Outlet />
    </>
  );
};

export default SideNavBar;
